import { z } from 'zod';
import { ErrorCode } from '../../shared/error-codes';
/**
 * Screenshot attachment limits, shared so the picker and the endpoint agree.
 *
 * The client-side checks are courtesy — telling someone their file is too big
 * before they wait for an upload — and the endpoint enforces the same numbers
 * again on bytes it has actually received.
 *
 * The ceiling is generous because a 5K screenshot is genuinely several
 * megabytes, and because the server shrinks and re-encodes anything oversized
 * before it reaches the helpdesk. Multipart, so the 1 MB JSON body limit in
 * main.ts does not apply.
 */ export const SUPPORT_ATTACHMENT_MAX_BYTES = 10 * 1024 * 1024;
export const SUPPORT_ATTACHMENT_MAX_COUNT = 5;
export const SUPPORT_ATTACHMENT_MIME_TYPES = [
    'image/png',
    'image/jpeg',
    'image/webp'
];
/** `accept` attribute for the file picker; mirrors the allowlist above. */ export const SUPPORT_ATTACHMENT_ACCEPT = SUPPORT_ATTACHMENT_MIME_TYPES.join(',');
/** Support ticket categories. Each maps to a Zammad group in the backend. */ export const SupportCategorySchema = z.enum([
    'incident',
    'request',
    'change',
    'complaint'
]);
/**
 * Create Support Ticket Request Schema
 * POST /api/v2/support/ticket
 *
 * Authenticated endpoint – user/tenant data is resolved from JWT context.
 * Frontend only sends category, summary, description + auto-collected metadata.
 */ export const CreateSupportTicketRequestSchema = z.object({
    category: SupportCategorySchema,
    summary: z.string().trim().min(1, ErrorCode.FIELD_REQUIRED).max(255),
    description: z.string().trim().min(1, ErrorCode.FIELD_REQUIRED).max(5000),
    appVersion: z.string().optional(),
    browser: z.string().optional()
});
/**
 * Create Support Ticket Response Schema
 */ export const CreateSupportTicketResponseSchema = z.object({
    ticketNumber: z.string(),
    // Zammad's internal id, distinct from the human-facing number. Needed so the
    // client can link straight to the new ticket's detail view — the number is
    // not addressable there.
    ticketId: z.number()
});

//# sourceMappingURL=create-support-ticket.schema.js.map